import { mutatorAction } from 'satcheljs';
import { connectedAccountsStore } from '../../store/store';
export var updateAdvancedLeaveCopy = mutatorAction('updateAdvancedLeaveCopy', function (leaveCopy) {
    var store = connectedAccountsStore();
    store.connectAdvancedState.leaveCopy = leaveCopy;
});
//# sourceMappingURL=updateAdvancedLeaveCopy.js.map